import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useCallback, useState } from "react";
import { Row, Col, CardBody, Card, Container, Button } from "reactstrap";
import { withRouter, Link } from "react-router-dom";
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";
import { Icon } from "leaflet";
import InvitedSpacesList from "components/ParentingSpace/InvitedSpacesList";
import { useParentingSpace } from "hooks/useParentingSpace";

const JoinParentingSpace = (props) => {
    const [showRoles, setShowRoles] = useState(false); // State to manage visibility of roles
    const [selectedRole, setSelectedRole] = useState("");
    const { createParentingSpace } = useParentingSpace(); // Destructure the function from the hook
    const [isLoading, setIsLoading] = useState(false);
 

    const handleCreateSpace = () => {
        setShowRoles(true); // Show roles when button is clicked
    };

    const roles = [
        { label: 'Lawyer', value: 'lawyers', icon: 'fa-gavel' },
        { label: 'Mediator', value: 'mediators',  icon: 'fa-balance-scale' },
        { label: 'Parenting Coordinator', value: 'parenting_coordinators', icon: 'fa-users' },
        { label: 'Parent', value: 'parents', logo: '/parent-logo.svg', icon: 'fa-child' },
        { label: 'Therapist', value: 'therapists',  icon: 'fa-user-md' },
    ];
    const handleRoleSelect = useCallback((role) => {
        setSelectedRole(role);
    }, []);

    const handleSubmit = useCallback(async () => {
        if (!selectedRole) {
            alert("Please select a role.");
            return;
        }
        try {
            setIsLoading(true);
          await createParentingSpace(selectedRole); // Call the createParentingSpace function
          setIsLoading(false);
        } catch (error) {
          console.error("Error creating parenting space:", error); // Handle error appropriately
        }
      }, [createParentingSpace, selectedRole]);

// const handleSubmit = () => {
//     // Logic to create a parenting space with the selected role
//     console.log(`Creating a parenting space as ${selectedRole}...`);
//     // Redirect or perform any action after creating the space
//     props.history.push("/some-path-after-creation"); // Change to your desired path
// };
return (

    <React.Fragment>
        <MetaTags>
            <title>Parenting Space</title>
        </MetaTags>
        <div className="home-btn d-none d-sm-block">
            <Link to="/" className="text-dark">
                <i className="fas fa-home h2" />
            </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
            <Container>
                <Row className="justify-content-center">
                    <Col  >
                        <Card className="overflow-hidden">
                            <div className="bg-primary bg-soft">
                                <Row>
                                    <Col xs={7} className="d-flex align-items-center justify-content-center">
                                        <div className="text-primary p-4">
                                            <h5 className="text-primary">Join Your Parenting Space</h5>
                                            <p>Connect with your co-parent and others</p>
                                        </div>
                                    </Col>
                                    <Col className="col-5 align-self-end">
                                        <img src={profile} alt="" className="img-fluid" />
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-0">
                                <div>
                                    <Link to="/" className="auth-logo-light">
                                        <div className="avatar-md profile-user-wid mb-4">
                                            <span className="avatar-title rounded-circle bg-light">
                                                <img
                                                    src={logo}
                                                    alt=""
                                                    className="rounded-circle"
                                                    height="34"
                                                />
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                                <div className="p-2">
                                    <Container>
                                        <Row>
                                             <InvitedSpacesList  />
                                        </Row>
                                        <Row className="justify-content-center">
                                            <Col md={10} lg={8} xl={6}>
                                                <div className="overflow-hidden">
                                                    <CardBody className="pt-4">
                                                        <div className="text-center">
                                                            <h3 className="text-primary mb-3">Create a Parenting Space</h3>
                                                            <p className="mb-4">Create a nurturing environment for your child by inviting co-parents and other members to join your parenting space.</p>
                                                        </div>
                                                        {/* <div className="mt-5 text-center">
                                                                <Button
                                                                    color="primary"
                                                                    className="btn-block btn-lg"
                                                                    onClick={handleCreateSpace}
                                                                >
                                                                    Create a Parenting Space
                                                                </Button>
                                                            </div> */}
                                                        <div className="text-center">
                                                            {!showRoles ? (
                                                                <Button
                                                                    color="primary"
                                                                    className="btn-block btn-lg"
                                                                    onClick={handleCreateSpace}
                                                                >
                                                                    Create a Parenting Space
                                                                </Button>
                                                            ) : (
                                                                <div>
                                                                    <h5>Select Your Role</h5>
                                                                    <ul className="list-unstyled">
                                                                        {roles.map((role) => (
                                                                            <li key={role} className={`role-item ${selectedRole === role.value ? 'active' : ''}`}>
                                                                                <div className={`d-flex align-items-center ${selectedRole === role.value ? 'bg-light' : ''}`}>
                                                                                    <Button
                                                                                        color="link"
                                                                                        onClick={() => handleRoleSelect(role.value)}
                                                                                        className="w-100 d-flex align-items-center justify-content-center"
                                                                                        style={{fontSize: '1.2em'}}
                                                                                    >
                                                                                        <div style={{marginRight: '10px'}}>
                                                                                            <i className={`fa ${role.icon}`}/>
                                                                                        </div>
                                                                                        <span>{role.label}</span>
                                                                                    </Button>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                    {selectedRole && (

                                                                        <Button
                                                                            color="primary"
                                                                            className="mt-3 btn-block btn-md w-100"
                                                                            onClick={handleSubmit}
                                                                        >
                                                                            {isLoading ? (
                                                                                <div className="spinner-border text-light" role="status">
                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                </div>
                                                                            ) : (
                                                                                "Create"
                                                                            )}
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            )}

                                                        </div>

                                                    </CardBody>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>
    </React.Fragment>
);
};

export default withRouter(JoinParentingSpace);

JoinParentingSpace.propTypes = {
    history: PropTypes.object,
};